import * as React from "react";
import BarChart from "../charts/bar";
import { useState, useEffect } from "react";
import { getJSONData } from "../utils";
import { orderBy } from "lodash";
import {
  SortAscendingIcon,
  SortDescendingIcon,
} from "@heroicons/react/outline";

const SocMedia = () => {
  const [socData, setSocData] = useState(null);
  const [sortData, setSortData] = useState(false);

  useEffect(() => {
    asyncFetch();
  }, []);
  const asyncFetch = () => {
    const getEvents = getJSONData(
      `${process.env.GATSBY_PATH_PREFIX}/data/cand_soc.json`
    );
    getEvents.then((data) => {
      setSocData(data);
    });
  };

  const getConfig = (data) => {
    data = sortData ? orderBy(data, ["value"], ["desc"]) : data;
    const config = {
      data,
      xField: "value",
      yField: "candidate",
      seriesField: "candidate",
      legend: {
        position: "left",
      },
    };
    return config;
  };
  return (
    <div className="rounded relative ">
      <div className="my-3">
        This section explores how each candidate leveraged social media in
        engaging with citizen, as captured by our dataset. This includes how
        often they shared messages (tweets they authored), how often others
        replied to their tweets, and how often they replied to others.{" "}
      </div>
      <div>
        {" "}
        <div
          role={"button"}
          onKeyDown={() => {
            setSortData(!sortData);
          }}
          onClick={() => {
            setSortData(!sortData);
          }}
          tabIndex={0}
          className="p-2 px-4 bg-indigo-100 boder mb-2 inline-block rounded text-sm hover:bg-indigo-200 border border-indigo-600"
        >
          {sortData ? (
            <span>
              <SortAscendingIcon className="w-6 inline-block" /> Order by
              Occurrence
            </span>
          ) : (
            <span>
              <SortDescendingIcon className="w-6 inline-block" /> Order by
              Frequency
            </span>
          )}
        </div>{" "}
      </div>
      {socData && (
        <div className="bg-white gap-4  flex-1 rounded  grid grid-col-1 md:grid-cols-3 ">
          <BarChart
            config={getConfig(socData.tweets)}
            title="Tweets Authored by candidate"
            description="Number of tweets created by each candidate."
          />
          <BarChart
            config={getConfig(socData.replies_to)}
            title="Replies to candidate tweets"
            description="Number of replies to tweets from each candidate."
          />
          <BarChart
            config={getConfig(socData.replies_by)}
            title="Candidate replies to others"
            description="Number of times candidates replied to other tweets."
          />
        </div>
      )}
    </div>
  );
};

export default SocMedia;
